import type { AxiosRequestConfig } from "axios";

import request from "@/plugins/axios";

import AlgorithmEnum from "@/api/algorithm/enums";

const isDev =
  process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test";
const url = !isDev ? "" : "/api";

/**
 * 可以评估的算法查询接口
 */
export function getAssessmentAlgorithm(pattern: string) {
  const config: AxiosRequestConfig = {
    url: `${url}${AlgorithmEnum.ALGORITHM_LIST}`,
    method: "post",
    data: {
      pattern,
    },
  };
  return request<
    {
      id: number;
      algorithmName: string;
      sample: string;
      codeUrl: string;
      templateHtml: string;
    }[]
  >(config);
}
